import request from '@/utils/request'

export function getOrderExtras (data) {
  return request({
    url: '/api/admin/order-extras',
    method: 'post',
    data: data
  })
}
